/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";

var ko = require("knockout");

var pliObservable = require("../forms-knockoutcontrols");
var stringUtil = require("../util/string");

var shared = require("./shared");

/**
 * @constructor
 * @this {DefaultAdvancedSearchItem}
 */
function DefaultAdvancedSearchItem() {
    if (!(this instanceof DefaultAdvancedSearchItem)) { return new DefaultAdvancedSearchItem(); } // if new was not used, force it now

    // indicates how the fields are searched
    // - `contains` includes any items with partial matches (default)
    // - `not contain` excludes any items with partial matches
    this.operator = ko.observable("contains");

    // contains value of the phrase to match
    this.value = pliObservable();
}


/**
 * @member {string}
 * stores the DOM ID of the template
 */
DefaultAdvancedSearchItem.prototype.templateId = "defaultAdvancedSearchItem";

/**
 * Loads the value of this view-model from the advancedSearch item
 * @param {string} phrase
 * @param {bool} not
 */
DefaultAdvancedSearchItem.prototype.load = function defaultAdvancedSearchItemLoad(phrase, not) {
    var textValue, operatorValue = "contains"; // default is "contains"

    if (not) {
        operatorValue = "not contain";
        textValue = phrase.replace(shared.removeSurroundingWildcards, "");
    } else if (stringUtil.isNullOrWhitespace(phrase)) {
        textValue = "";
    } else {
        phrase = phrase.trim();
        textValue = phrase.replace(shared.removeSurroundingWildcards, "");
    }

    this.operator(operatorValue);
    this.value.load(textValue);
};


/**
 * Saves the value of this view-model to the advancedSearch item
 * @returns {Array} - [0] is `phrase`, [1] is `not`
 */
DefaultAdvancedSearchItem.prototype.save = function defaultAdvancedSearchItemSave() {
    var phrase, not,
        operator = this.operator(),
        value = this.value();
    value = stringUtil.isNullOrWhitespace(value) ? "" : value;

    phrase = (value === ""
        ? value
        : value.replace(shared.removeSurroundingWildcards, ""));
    not = operator === "not contain";

    return [phrase, not];
};

module.exports = DefaultAdvancedSearchItem;




//////////////////
// WEBPACK FOOTER
// ./~/pli/advancedsearch/defaultAdvancedSearchItem.js
// module id = 14
// module chunks = 49